import { Icon } from "antd";

const OrderInfoSection = ({ icon, title, children }) => {
    return (
        <div style={{ marginBottom: '24px' }}>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                marginBottom: '8px'
            }}>
                <Icon type={icon} style={{ color: '#666' }} />
                <span style={{ fontWeight: '600', color: '#666' }}>{title}</span>
            </div>
            <div style={{ marginLeft: '24px' }}>
                {children}
            </div>
        </div>
    );
};

export default OrderInfoSection;
